<div class="main">
    <img *ngIf="type == 'image'" class="thumbnail" src="{{asset}}" (click)="openDialog()">
    <img *ngIf="type == 'pdf'" class="pdfIcon" src="assets/PDF-icon.svg" (click)="openDialog()">
  </div>
  <ng-template #preview>
    <div class="dialogMain">
      <div class="header">
        <div class="title">
          Preview
        </div>
        <div class="icons">
          <div class="icon">
            <a [href]="asset" download >
              <img src="assets/download_link.svg" alt="" width="30" height="20" style="cursor: pointer; color: #fff;">
            </a>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="image" *ngIf="type == 'image'">
          <img class="preview-image" src="{{asset}}">
        </div>
        <div class="pdf" *ngIf="type == 'pdf'">
          <embed [src]="sanitize(asset)" width="820px" height="400px" type="application/pdf"
          frameBorder="0"
          scrolling="auto" />
          <object [data]="sanitize(asset)" type="application/pdf" width="100px" height="592px"></object>
        </div>
      </div>
    </div>
  